import { Validators } from "@angular/forms";

export const phoneNumberValidatorPattern = /^\+[1-9][\d]{0,15}$/;
